/**
 * Converts camelCase or ALL_CAPS strings into Proper Case
 * @param str - The input string to convert
 * @returns The converted string in proper case
 */
export const toProperCase = (str: string): string => {
  return str
    .replace(/([A-Z])/g, ' $1') // split camelCase
    .replace(/_/g, ' ')         // replace underscores
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize words
};
